import { useState } from "react";
import {
  Grid,
  TextField,
  IconButton,
  Box,
  Tooltip,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Search, Refresh } from "@mui/icons-material";
import moment from "moment";

const NameDateSearchComponent = ({ onSearch }) => {


  const [startDate, setStartDate] = useState(
    moment().subtract(30, "days").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));

  // const [startDate, setStartDate] = useState("");
  // const [endDate, setEndDate] = useState("");
  const [customerName, setCustomerName] = useState("");

  // ✅ Get screen size for responsiveness
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md")); // sm = 600px

  const handleSearch = () => {
    onSearch(startDate || null, endDate || null, customerName || null);
  };

  const handleReset = () => {


        const defaultStartDate = moment().subtract(30, "days").format("YYYY-MM-DD");
        const defaultEndDate = moment().format("YYYY-MM-DD");
    
        setStartDate(defaultStartDate);
        setEndDate(defaultEndDate);
    // setStartDate("");
    // setEndDate("");
    setCustomerName("");
    onSearch(null, null, null);
  };

  return (
    <Box
      display="flex"
      flexDirection={isMobile ? "column" : "row"} // ✅ Stack vertically on mobile
      alignItems={isMobile ? "stretch" : "center"}
      justifyContent={isMobile ? "flex-start" : "flex-end"}
      gap={isMobile ? 2 : 1} // ✅ Keep spacing on both but more flexible on mobile
      // p={2}
      width="100%"
    >
      {/* Name Field */}
      <TextField
        size="small"
        label="Name"
        type="text"
        value={customerName}
        onChange={(e) => setCustomerName(e.target.value)}
        // InputLabelProps={{ shrink: true }}
        variant="outlined"
        fullWidth={isMobile} // ✅ Full width on mobile
      />

      <Box display="flex"
        gap={isMobile ? 0.5 : 1}
      >

        {/* Start Date */}
        <TextField
          name="startDate"
          id="startDate"
          size="small"
          label="Start Date"
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          variant="outlined"
          fullWidth={isMobile} // ✅ Full width on mobile
        />

        {/* End Date */}
        <TextField
          name="endDate"
          id="endDate"
          size="small"
          label="End Date"
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          variant="outlined"
          fullWidth={isMobile} // ✅ Full width on mobile
        />
        {/* Search & Reset Buttons */}


        <Box
          display="flex"
          flexDirection="row"
          justifyContent={isMobile ? "flex-end" : "center"}
          gap={isMobile ? 0.5 : 0} // ✅ Smaller gap on mobile
        >
          <Tooltip title="Search">
            <IconButton
              color="primary"
              onClick={handleSearch}
              size={isMobile ? "small" : "medium"} // ✅ Reduce button size on mobile
              sx={{
                p: isMobile ? "0px" : "4px", // ✅ Less padding on mobile
              }}
            >
              <Search
                sx={{
                  // fontSize: isMobile ? 25 : 28, // ✅ Smaller icon on mobile
                }}
              />
            </IconButton>
          </Tooltip>

          <Tooltip title="Reset">
            <IconButton
              color="secondary"
              onClick={handleReset}
              size={isMobile ? "small" : "medium"}
              sx={{
                p: isMobile ? "0px" : "4px", // ✅ Less padding on mobile
              }}
            >
              <Refresh
                sx={{
                  // fontSize: isMobile ? 25 : 28, // ✅ Smaller icon on mobile
                }}
              />
            </IconButton>
          </Tooltip>
        </Box>


        {/* <Box
          display="flex"
          flexDirection="row"
          justifyContent={isMobile ? "flex-end" : "center"}
        >
          <Tooltip title="Search">
            <IconButton color="primary" onClick={handleSearch} >
              <Search size={500} />
            </IconButton>
          </Tooltip>

          <Tooltip title="Reset">
            <IconButton color="secondary" onClick={handleReset}>
              <Refresh />
            </IconButton>
          </Tooltip>
        </Box> */}


      </Box>


    </Box>
  );
};

export default NameDateSearchComponent;




// import { useState } from "react";
// import {
//   Grid,
//   TextField, IconButton, Box, Tooltip
// } from "@mui/material";
// import { Search, Refresh } from "@mui/icons-material";

// const NameDateSearchComponent = ({ onSearch }) => {
//   const [startDate, setStartDate] = useState("");
//   const [endDate, setEndDate] = useState("");
//   const [customerName, setCustomerName] = useState("");
//   // console.log("namefield", onSearch);

//   const handleSearch = () => {
//     onSearch(startDate || null, endDate || null, customerName || null);
//   };

//   const handleReset = () => {
//     setStartDate("");
//     setEndDate("");
//     setCustomerName("");
//     onSearch(null, null, null); // Reset the filters
//   };

//   return (
//     <Box
//       display="flex"
//       flexDirection="row"
//       alignItems="center"
//       justifyContent="flex-end"
//       gap={2}
//       p={2}
//     >

//       <TextField
//         size="small"
//         label="Name"
//         type="text"
//         value={customerName}
//         onChange={(e) => setCustomerName(e.target.value)}
//         InputLabelProps={{ shrink: true }}
//         variant="outlined"
//       />

//       <TextField
//         name="startDate"
//         id="startDate"
//         size="small"
//         label="Start Date"
//         type="date"
//         value={startDate}
//         onChange={(e) => setStartDate(e.target.value)}
//         InputLabelProps={{ shrink: true }}
//         variant="outlined"
//       />


//       <TextField
//         name="endDate"
//         id="endDate"
//         size="small"
//         label="End Date"
//         type="date"
//         value={endDate}
//         onChange={(e) => setEndDate(e.target.value)}
//         InputLabelProps={{ shrink: true }}
//         variant="outlined"

//       />


//       <Box>
//         {/* Search Icon Button */}
//         <Tooltip title="Search">
//           <IconButton color="primary" onClick={handleSearch}>
//             <Search />
//           </IconButton>
//         </Tooltip>

//         {/* Reset Icon Button */}
//         <Tooltip title="Reset">
//           <IconButton color="secondary" onClick={handleReset}>
//             <Refresh />
//           </IconButton>
//         </Tooltip>
//       </Box>
//     </Box>
//   );
// };

// export default NameDateSearchComponent;
